import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useNavigate } from 'react-router-dom';

const visaCards = [
    { id: 1, key: 'us', title: 'US Visa', slug: 'us-visa', img: '/img/us.jpg' },
    { id: 2, key: 'uk', title: 'UK Visa', slug: 'uk-visa', img: '/img/uk.jpeg' },
    { id: 3, key: 'canada', title: 'Canada Visa', slug: 'canada-visa', img: '/img/canada.jpg' },
    { id: 4, key: 'japan', title: 'Japan Visa', slug: 'japan-visa', img: '/img/japan.jpg' }
];


const VisaCards = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    useEffect(() => {
        apiRequest({ url: "/visa" })
            .then((res) => {
                if (res.success && Array.isArray(res.data)) {
                    setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            });
    }, []);

    return (
        <section className='bg-light py-5'>
            <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
                <h5 className="section-title px-3">What We Offer</h5>
                <h1 className="mb-0">Visa Services for Top Countries</h1>
            </div>

            <div className="container">
                <div className="row">
                    {data.map((visa) => (
                        <div key={visa.id} className="col-md-3 mb-3">
                            <div
                                className="card rounded overflow-hidden text-center"
                                style={{ cursor: 'pointer' }}
                                // onClick={() => navigate(`/visa/${visa.slug}`)}
                                onClick={() => navigate(`/visa/${visa.slug}`, { state: visa.id })}
                            >
                                <img src={visa.img} alt={visa.title} className="card-img-top" style={{ height: '200px', objectFit: 'cover', width: '100%' }} />
                                <div className="card-body p-1">
                                    <h6 className="card-title mb-0">{visa.title}</h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default VisaCards;
